import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { liveStreams } from "./MarketplaceData/MarketplaceData";

const LiveStreams = () => {
    return (
        <div className="">
            <div className="mb-7">
                <div className="mb-3">
                    <h3 className="text-base text-ebony-color font-medium capitalize">
                        Getting started
                    </h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {liveStreams.slice(0, 4).map((stream) => (
                        <AllStreams stream={stream} key={stream.id} />
                    ))}
                </div>
            </div>

            <div className="mb-7">
                <div className="mb-3">
                    <h3 className="text-base text-ebony-color font-medium capitalize">
                        Just for you
                    </h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {liveStreams.slice(4, 8).map((stream) => (
                        <AllStreams stream={stream} key={stream.id} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export const AllStreams = ({ stream, key }) => {
    const navigate = useNavigate();
    return (
        <div
            key={stream.id}
            className="border border-black-10 rounded-lg w-full mx-auto sm:m-0"
        >
            <div className="mb-5 relative">
                <img
                    src={stream.img}
                    className="w-full rounded-tl-lg rounded-tr-lg"
                    alt=""
                />
                <div
                    onClick={() => navigate("/replay")}
                    className="absolute top-0 left-0 right-0 w-full bottom-0 flex flex-col justify-between bg-black bg-opacity-10 cursor-pointer"
                >
                    <div className="px-2 pt-2.5 flex items-start justify-end text-white">
                        <BsThreeDotsVertical className="text-2xl cursor-pointer" />
                    </div>
                    <div className="flex justify-between p-1.5">
                        <div className="cursor-pointer flex items-center">
                            <img
                                src={stream?.users?.userImg}
                                className="w-8 h-8 border border-white rounded-full"
                                alt=""
                            />
                            <h5 className="text-sm font-medium capitalize text-white ml-2">
                                {stream?.users?.user1}
                            </h5>
                        </div>
                        <button
                            onClick={() => navigate("/replay")}
                            className="text-sm font-bold text-white py-0.5 px-2 rounded-[5px] bg-orange-color"
                        >
                            {stream.duration}
                        </button>
                    </div>
                </div>
            </div>
            <div className="px-4 pb-[18px]">
                <div className="overflow-x-auto overflow-y-hidden mb-2.5 flex gap-x-2">
                    <h4 className="text-base font-bold text-ebony-color">
                        {stream.title}
                    </h4>
                </div>
                <div className="flex items-center mb-2.5">
                    <div className="relative">
                        <img
                            src={stream?.users?.userImg}
                            alt=""
                            className="w-8 h-8 rounded-full"
                        />
                        <div className="absolute top-2/4 -translate-y-2/4 translate-x-2/4">
                            <div className="relative">
                                <img
                                    src={stream?.users?.userImg}
                                    alt=""
                                    className="w-8 h-8 rounded-full"
                                />
                                <div className="absolute top-2/4 -translate-y-2/4 translate-x-2/4">
                                    <div className="relative">
                                        <img
                                            src={stream?.users?.userImg}
                                            alt=""
                                            className="w-8 h-8 rounded-full"
                                        />
                                        <div className="absolute top-2/4 -translate-y-2/4 translate-x-2/4">
                                            <div className="relative">
                                                <img
                                                    src={stream?.users?.userImg}
                                                    alt=""
                                                    className="w-8 h-8 rounded-full"
                                                />
                                                <div className="absolute top-2/4 -translate-y-2/4 translate-x-2/4">
                                                    <div className="relative">
                                                        <div className="bg-gray-300 w-8 h-8 rounded-full border border-white flex items-center justify-center text-sm font-medium">
                                                            <span>+2</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex items-center gap-x-3">
                    <div className="text-sm text-black-50 font-medium flex items-center hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                fill="none"
                                className="mr-2.5 stroke-current"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9.99984 5.99998C9.99984 7.10455 9.10441 7.99998 7.99984 7.99998C6.89527 7.99998 5.99984 7.10455 5.99984 5.99998C5.99984 4.89541 6.89527 3.99998 7.99984 3.99998C9.10441 3.99998 9.99984 4.89541 9.99984 5.99998Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M1.63867 5.99996C2.48819 3.29523 5.01504 1.33331 8.00013 1.33331C10.9852 1.33331 13.5121 3.29526 14.3616 6C13.5121 8.70473 10.9852 10.6666 8.00014 10.6666C5.01504 10.6666 2.48817 8.70471 1.63867 5.99996Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                        <p>{stream.watch}</p>
                    </div>
                    <div className="text-sm text-black-50 font-medium flex items-center hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                                stroke="currentColor"
                                className="mr-2.5"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.3333 4.33335H11.6667C12.403 4.33335 13 4.93031 13 5.66669V9.66669C13 10.4031 12.403 11 11.6667 11H10.3333V13.6667L7.66667 11H5C4.63181 11 4.29848 10.8508 4.05719 10.6095M4.05719 10.6095L6.33333 8.33335H9C9.73638 8.33335 10.3333 7.7364 10.3333 7.00002V3.00002C10.3333 2.26364 9.73638 1.66669 9 1.66669H2.33333C1.59695 1.66669 1 2.26364 1 3.00002V7.00002C1 7.7364 1.59695 8.33335 2.33333 8.33335H3.66667V11L4.05719 10.6095Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                        <p>{stream.comment}</p>
                    </div>
                    <div className="text-sm text-black-50 font-medium flex items-center hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                className="mr-2.5 stroke-current"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7 3V7H10M13 7C13 7.78793 12.8448 8.56815 12.5433 9.2961C12.2417 10.0241 11.7998 10.6855 11.2426 11.2426C10.6855 11.7998 10.0241 12.2417 9.2961 12.5433C8.56815 12.8448 7.78793 13 7 13C6.21207 13 5.43185 12.8448 4.7039 12.5433C3.97595 12.2417 3.31451 11.7998 2.75736 11.2426C2.20021 10.6855 1.75825 10.0241 1.45672 9.2961C1.15519 8.56815 1 7.78793 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                        <p>{stream.date}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LiveStreams;
